<template>
  <div class="page">
    <side-icons />
    <section class="section">
      <el-tabs v-model="activeName" :tab-position="position">
        <el-tab-pane label="Oral Presentation" name="first">
          <div class="text-center"><h3 class="fs-36 text-decoration section-title">Oral Presentation</h3></div>
          <div class="list">
            <div v-for="item in oralPageList" :key="item.id" class="item">
              <p class="title">{{ item.title }}</p>
              <div class="text">
                <p class="text-info">
                  <i class="iconfont icon-geren" />
                  <span class="margin-right-20px">{{ item.role }}</span>
                </p>
                <p class="text-info">
                  <i class="el-icon-date" />
                  <span class="margin-right-20px">{{ item.time }}</span>
                </p>
                <p class="text-info">
                  <i class="iconfont icon-dingwei" />
                  <span>{{ item.location }}</span>
                </p>
              </div>
            </div>
            <!-- 分页 -->
            <div class="pagination margin-top-20px">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                :total="total"
                @current-change="pageChange"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Professional Activities" name="second">
          <div class="text-center"><h3 class="fs-36 text-decoration section-title">Professional Activities</h3></div>
          <div class="list first-list">
            <el-divider content-position="left"><h4 class="fs-18 list-title">Reviewer for Grants</h4></el-divider>
            <ol class="sub-list text-normal">
              <li v-for="item in grantsList" :key="item">{{ item }}</li>
            </ol>
          </div>
          <div class="list">
            <el-divider content-position="left"><h4 class="fs-18 list-title">Examiner of Ph.D. dissertation</h4></el-divider>
            <ol class="sub-list text-normal">
              <li v-for="item in examinerList" :key="item">{{ item }}</li>
            </ol>
          </div>
          <div class="list">
            <el-divider content-position="left"><h4 class="fs-18 list-title">Reviewer for Journals</h4></el-divider>
            <div class="flex sub-list text-normal">
              <ol class="flex-1 padding-right-30px">
                <li v-for="item in reviwerList.slice(0, 20)" :key="item">{{ item }}</li>
              </ol>
              <ol start="21" class="flex-1">
                <li v-for="item in reviwerList.slice(20)" :key="item">{{ item }}</li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Conference & Workshop Organizer" name="third">
          <div class="text-center"><h3 class="fs-36 text-decoration section-title">Conference & Workshop Organizer</h3></div>
          <div class="list">
            <div v-for="item in organizerList" :key="item.title" class="item">
              <p class="title">{{ item.title }}</p>
              <div class="text flex flex-wrap">
                <p class="text-info bold">
                  <i class="iconfont icon-geren" />
                  <span class="margin-right-20px" v-html="item.role" />
                </p>
                <p class="text-info">
                  <i class="el-icon-date" />
                  <span class="margin-right-20px" v-html="item.time" />
                </p>
                <p class="text-info">
                  <i class="iconfont icon-dingwei" />
                  <span v-html="item.location" />
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>
<script type="text/javascript">
import SideIcons from '@/components/sideIcons/sideIcons'
import jsData from '@/data/activities.js'
import topMixin from '@/components/sideIcons/topMixin'
export default {
  components: { SideIcons },
  mixins: [topMixin],
  data() {
    return {
      page: 1,
      pageSize: 9,
      oralPageList: [],
      activeName: 'first'
    }
  },
  computed: {
    isPc() {
      return this.device === 'pc'
    },
    position() {
      return this.isPc ? 'left' : 'top'
    },
    total() {
      return this.oralList.length
    },
    oralList() {
      return jsData.oral.map((item, index) => {
        const arr = item.split(',')
        return {
          id: index,
          role: arr[0],
          title: arr[1].replace(/"/g, ''),
          location: arr[2] + ',' + arr[3],
          time: arr[4] + ',' + arr[5]
        }
      })
    },
    grantsList() {
      return jsData.pro.grants
    },
    examinerList() {
      return jsData.pro.examiner
    },
    reviwerList() {
      return jsData.pro.reviwer
    },
    organizerList() {
      return jsData.organizer.map(item => {
        const arr = item.split(',')
        return {
          role: arr[0],
          title: arr[1].replace(/"/g, ''),
          location: arr[2],
          time: arr[3]
        }
      })
    }
  },
  created() {
    this.oralPageList = this.oralList.slice(0, this.pageSize)
  },
  methods: {
    pageChange(val) {
      this.page = val
      this.oralPageList = this.oralList.slice((val - 1) * this.pageSize, val * this.pageSize)
      this.toTop()
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  .section{
    padding-left: 260px;
    &:last-child{
      padding-bottom: 4vw;
    }
    .section-title{
      margin-bottom: 30px;
    }
    li{
      margin-bottom: 10px;
    }
    /deep/ .el-tabs--left .el-tabs__header.is-left{
      position: fixed;
      height: auto;
      left: 0; top: 40%;
      .el-tabs__item.is-active{
        font-weight: bold;
      }
    }
  }
  .list{
    padding-top: 0;
    .item{
      .text{
        margin-top: 16px;
      }
    }
    .sub-list{
      padding: 10px 20px 10px 56px;
    }
  }
  .icon-dingwei{
    margin-right: 2px !important;
  }
  .text-info{
    margin-bottom: 0;
    display: inline-block;
  }
}

@media screen and (max-width: 760px){
  .section{
    padding-left: 4vw !important;
    .section-title{
      margin-top: 10px;
      margin-bottom: 0 !important;
    }
  }
  .text-info{
    display: block !important;
    margin-bottom: 10px !important;
    &:last-child{
      margin-bottom: 0;
    }
  }
  .sub-list{
    display: block;
  }
  .first-list{
    padding-top: 10px !important
  }
}
</style>
